<div class="invite-dialog">

    <!-- Close Button -->
    <button mat-icon-button class="close-btn" (click)="close()">
        <mat-icon>close</mat-icon>
    </button>

    <h2>Invite Student</h2>
    <p class="subtitle">
        Send an invitation to a new student. Email must be from the institutional domain.
    </p>

    <!-- FULL NAME -->
    <div class="form-group full-width">
        <label class="field-label">Full Name</label>
        <mat-form-field appearance="outline" class="full-width compact-field">
            <input matInput [(ngModel)]="fullName" placeholder="Dr. John Doe" />
        </mat-form-field>
    </div>

    <!-- EMAIL -->
    <div class="form-group full-width">
        <label class="field-label">Email Address</label>
        <mat-form-field appearance="outline" class="full-width compact-field">
            <input matInput [(ngModel)]="email" placeholder="john.doe@sit.ac.in" />
        </mat-form-field>
    </div>

    <!-- BATCH DROPDOWN -->
    <div class="form-group full-width">
        <label class="field-label">Batch</label>
        <mat-form-field appearance="outline" class="full-width compact-field">
            <mat-select [(ngModel)]="selectedBatchId">

                <mat-option *ngFor="let b of batches" [value]="b.id">
                    {{ b.name }}
                </mat-option>

                <mat-option class="create-batch-option" (click)="openCreateBatchDialog()">
                    <mat-icon>add</mat-icon> Create Batch
                </mat-option>

            </mat-select>
        </mat-form-field>


    </div>

    <!-- DEPARTMENT DROPDOWN -->
    <div class="form-group full-width">
        <label class="field-label">Department</label>

        <mat-form-field appearance="outline" class="full-width compact-field">
            <mat-select [(ngModel)]="selectedDepartmentId" (selectionChange)="onSelectDepartment($event.value)"
                (openedChange)="onOpenDepartment($event)">

                <mat-select-trigger>
                    {{ selectedDepartmentName || 'Select Department' }}
                </mat-select-trigger>

                <!-- ✅ Loop Departments -->
                <mat-option *ngFor="let d of filteredDepartments" [value]="d.id">
                    {{ d.name }}
                </mat-option>

            </mat-select>
        </mat-form-field>
    </div>

    <!-- ACTION BUTTONS -->
    <div class="actions">
        <button mat-stroked-button (click)="close()">Cancel</button>

        <button mat-flat-button color="primary" class="dark-blue" (click)="sendInvite()">
			<ng-container *ngIf="isLoading; else noLoading">
            <span class="spinner-border spinner-border-sm"></span> Sending...</ng-container>
		    <ng-template #noLoading> Send Invitation</ng-template>
        </button>
    </div>
</div>